export default "__VITE_ASSET__CRQM79Nm__"